// src/App.js
import '@fortawesome/fontawesome-free/css/all.min.css';
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ConnectionPage from './pages/ConnectionPage';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import EditConnectionPage from './pages/EditConnectionPage';
import ConnectionPageFake from './pages/ConnectionPageFake';
function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/edit-connection" element={<EditConnectionPage />} />
        {/* Dynamic route for connection pages */}
        <Route path="/:uuid" element={<ConnectionPageFake />} />
        <Route path="/" element={<div>Home Page</div>} />
      </Routes>
    </Router>
  );
}

export default App;
